import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Employee from 'src/app/model/product/employee';
import { SubProject } from 'src/app/model/project/sub-project';
import { EmployeeChoicesService } from 'src/app/services/employee-choices.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'ip-board-delay',
  templateUrl: './ip-board-delay.component.html',
  styleUrls: ['./ip-board-delay.component.scss']
})
export class IPBoardDelayComponent extends SubscriptionBasedComponent
  implements OnInit {
  @Input()
  subProject: SubProject;

  @Output()
  save = new EventEmitter<void>();

  @Output()
  delayed = new EventEmitter<boolean>();

  delayHandlerOptions: Employee[];

  constructor(private employeeChoicesService: EmployeeChoicesService) {
    super();
  }

  ngOnInit(): void {
    if (this.subProject.delayed) {
      this.employeeChoicesService.updateImmoAdminChoices();
    }
    this.addSubscription(
      this.employeeChoicesService.getImmoAdminChoicesSubscribable(),
      (immoAdmins: Employee[]) => (this.delayHandlerOptions = immoAdmins)
    );
  }

  delayedChanged(): void {
    if (this.subProject.delayed) {
      this.employeeChoicesService.updateImmoAdminChoices();
    }
    this.delayed.emit(this.subProject.delayed);
  }

  delayedReasonChanged(reason: string): void {
    this.subProject.delayedReason = reason;
    this.save.emit();
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }
}
